import {
  BorderedCircleSkeleton,
  LineSkeleton
} from 'components/base/Skeletons';
import {
  LineGroupSkeleton,
  StyledSkeletonSection
} from '../projects.builder.style';

const ProjectColumnSkeleton = ({
  circle,
  Icon,
  lines,
  withoutAnimation = false
}) => {
  return (
    <StyledSkeletonSection>
      {circle && (
        <BorderedCircleSkeleton
          borderSize={10}
          withoutAnimation={withoutAnimation}
        />
      )}
      {Icon && Icon}
      <LineGroupSkeleton>
        {lines.map((line, index) => (
          <LineSkeleton
            key={index}
            size={line.width}
            withoutAnimation={withoutAnimation}
          />
        ))}
      </LineGroupSkeleton>
    </StyledSkeletonSection>
  );
};

export default ProjectColumnSkeleton;
